fragment OrderItemFragment on OrderItem {

    order_id
    product_id

    product {
        ...ProductFragment
    }

    orderItemProductVariations {
        ...OrderItemProductVariationFragment
    }

    orderItemAttachments {
        ...OrderItemAttachmentFragment
    }

    orderItemPrints {
        ...OrderItemPrintFragment
    }

    item_no

    name
    description

    notes

    total_product_variation_quantity
    total_attachment_quantity
    total_imprint_quantity
    total_start_quantity
    total_handling_charge_quantity

    pcs_product_variation_cost
    total_product_variation_cost

    pcs_attachment_cost
    total_attachment_cost

    pcs_imprint_cost
    total_imprint_cost

    pcs_start_cost
    total_start_cost

    pcs_print_handling_charge
    total_print_handling_charge

    pcs_price
    total_price

    discount
}